import React, { FunctionComponent } from 'react'
import { List, Switch } from 'antd'
import { useLocalStorage } from 'usehooks-ts'

interface IProps {
  key: string
  localStorageKey: string
  title: string
  defaultValue: boolean
}

const ToggleOption: FunctionComponent<any> = (props: IProps) => {
  const { title, defaultValue, localStorageKey } = props
  const [enabled, setEnabled] = useLocalStorage(localStorageKey, defaultValue)
  return (
    <List.Item extra={<Switch checked={enabled} onChange={(e: boolean) => setEnabled(e)} />}>
      <List.Item.Meta title={title} />
    </List.Item>
  )
}

export default ToggleOption
